export default __webpack_public_path__ + "static/media/CormorantGaramondItalic.6c76b84d.woff";